import { compose } from 'redux';
import { ModalMenu as ModalMenuComponent } from './ModalMenu';
import { EnhancedComponentType, withContainer } from './withContainer';

const ModalMenu = compose<EnhancedComponentType>(
  withContainer,
)(ModalMenuComponent);

export {
  ModalMenu,
};
export * from './withContainer';
